<template lang="pug">
    .lavages-block(:class="{'lavages-block--re-contact': isReContact, 'lavages-block--addition-only': additionOnly}")
        .lavages-block__row(
            v-for="(item, index) in lavages"
            :key="item.id"
            :class="{old: item.old}"
        )
            .row
                app-datepicker.lavages-block--date(
                    v-model="item.date"
                    label="Дата проведения"
                    :error="getFieldError(item, index, 'date')"
                )
                app-select.lavages-block--select(
                    v-model="item.procedure"
                    :options="lavagesList"
                    searchable
                    label="Исследование"
                    :error="getFieldError(item, index, 'procedure')"
                )
                app-dropper.forDesktop(
                    :class="{hidden: (isReContact || additionOnly) && item.old}"
                    @click="dropLavage(index)"
                )
            .row
                app-text-field.lavages-block--textarea(
                    v-model="item.result"
                    label="Результат"
                    is-textarea
                    :error="getFieldError(item, index, 'result')"
                )
                app-dropper.forMobile_or_p(
                    :class="{hidden: (isReContact || additionOnly) && item.old}"
                    @click="dropLavage(index)"
                )
            hr.narrow(v-if="index < lavages.length - 1")
        .br
        app-button(
            plus
            @click="addNewLavage"
        ) Добавить

</template>

<script>
import { uniqueId } from 'lodash';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';

export default {
    name: 'lavages-block',

    props: {
        value: {
            type: Array,
            required: true,
        },

        isReContact: {
            type: Boolean,
            required: false,
            default: false,
        },

        additionOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data: () => ({
        lavages: [],
    }),

    validations: {
        lavages: {
            $each: {
                date: { required },
                procedure: { required },
                result: { required },
            },
        },
    },

    computed: {
        lavagesList() {
            return [
                {
                    id: '1',
                    name: 'Бронхоальвеолярный лаваж',
                },
            ];
        },
    },

    watch: {
        lavages(value) {
            this.$emit('input', value);
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.lavages = this.value;
        });
    },

    methods: {
        addNewLavage() {
            this.lavages.push({
                id: uniqueId(),
                date: '',
                procedure: '',
                result: '',
            });
            this.$v.$reset();
        },

        dropLavage(index) {
            this.$confirm({
                message: `Вы действительно хотите удалить процедуру?`,
                button: {
                    no: 'Нет',
                    yes: 'Да',
                },
                callback: confirm => {
                    if (confirm) {
                        this.lavages = this.lavages.filter((d, i) => i !== index);
                    }
                },
            });
        },

        getFieldError(item, index, field) {
            if (this.$v.lavages.$each.$iter[index].$dirty && !this.$v.lavages.$each.$iter[index][field].required) {
                return 'Заполните поле';
            }
            return null;
        },

        getFieldsForSave() {
            return this.lavages.map(d => {
                return {
                    date_at: moment(d.date).format('YYYY-MM-DD'),
                    result: d.result,
                };
            });
        },

        getFormattedSavedFields(lavages) {
            let fields = lavages.map(d => ({
                id: d.id,
                date: +moment(d.date_at),
                procedure: this.lavagesList[0],
                result: d.result,
                old: true,
            }));
            fields.sort((f1, f2) => f1.date - f2.date);
            return fields;
        },
    },
};
</script>

<style lang="scss">
.lavages-block {
    .lavages-block {
        &--date {
            width: rem(200px);
        }

        &--select {
            width: rem(438px);
        }

        &--textarea {
            max-width: rem(1048px);
        }
    }

    &--re-contact {
        .lavages-block__row.old {
            display: none;
        }
    }

    &--addition-only {
        .lavages-block__row.old {
            .app-text-field, .app-select, .app-datepicker {
                opacity: 0.5;

                pointer-events: none;
            }
        }
    }

    @include mobile_or_P {
        .lavages-block {
            &--date,
            &--select {
                width: 100%;
            }
        }
    }
}
</style>
